import './helpers.scss';

export const disableScroll = () => {
    if (! $(document.body).hasClass('is-scroll-disabled')) {
        const curScroll      = $(window).scrollTop();
        const headerPosition = getComputedStyle($('.header').get(0)).position;

        $(document.body).addClass('is-scroll-disabled');
        $('.page-wrapper').css('top', -curScroll);

        if (headerPosition === 'sticky') {
            $('.header').css('top', curScroll);
        }

        $(window).scrollTop(0);
    }
};

export const enableScroll = () => {
    const bodyScroll     = parseInt($('.page-wrapper').css('top'), 10);
    const headerPosition = getComputedStyle($('.header').get(0)).position;

    $(document.body).removeClass('is-scroll-disabled');

    if (headerPosition === 'sticky') {
        $('.header').removeAttr('style');
    }

    if (bodyScroll) {
        document.documentElement.style.scrollBehavior = 'auto';
        setTimeout(() => window.scrollTo(0, -bodyScroll), 5);
        setTimeout(() => document.documentElement.style.scrollBehavior = 'smooth', 5);
    }
};

export const setCookie = (cookieName, cookieValue, expirationDays) => {
    const d = new Date();

    d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));

    const expires = 'expires='+ d.toUTCString();

    document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
};

export const getCookie = (cookieName) => {
    const name          = cookieName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca            = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }

    return false;
};

export const setBodyLoader = () => {
    $(document.body).addClass('is-loading');
};

export const removeBodyLoader = () => {
    $(document.body).removeClass('is-loading');
};

export const getHash = () => window.location.hash;

export const scrollToElement = (target, offset = 0, duration = 150) => {
    if (typeof target === 'undefined') {
        return false;
    }

    if (target instanceof jQuery) { // make target to node IF jQuery object
        target = target[0]; // eslint-disable-line
    }

    const paddingTop = parseInt($(target).css('padding-top'));
    const marginTop  = parseInt($(target).css('margin-top'));

    const targetSpacingTop = paddingTop + marginTop;

    const header         = $('.header');
    const headerInner    = header.find('.header__container');
    const headerPosition = getComputedStyle(header.get(0)).position;
    const headerHeight   = headerInner.innerHeight();

    let top = target.getBoundingClientRect().top - document.body.getBoundingClientRect().top;

    if ((headerPosition === 'fixed' || headerPosition === 'sticky') && targetSpacingTop < headerHeight) {
        top -= headerHeight;
    }

    const scrollAmount = top - offset;

    if (duration === 0) {
        window.scroll({
            top: scrollAmount,
            left: 0,
            behavior: 'instant',  // or 'auto'
        });
    } else {
        $('html, body').stop(true, false).animate({
            scrollTop: scrollAmount,
        }, duration);
    }
};

export const isElementPartiallyInViewport = (element) => {
    const rect = element.getBoundingClientRect();

    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth  = (window.innerWidth || document.documentElement.clientWidth);

    const vertInView = (rect.top <= windowHeight / 2) && ((rect.top + rect.height) >= 0);
    const horInView  = (rect.left <= windowWidth / 2) && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
};

export const getRootCssVariable = (variableName) => {
    const root       = document.documentElement;
    const rootStyles = getComputedStyle(root);
    let value        = rootStyles.getPropertyValue(variableName);

    value = value.trim();

    if (value.includes('px')) {
        value = parseFloat(value);
    }

    return value;
};

export const focusAndOpenKeyboard = (target, timeoutDuration) => {
    if (!target) {
        return;
    }

    const timeout = timeoutDuration || 100;
    // const isIos   = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    const placeCursorAtEnd = (inputElement) => {
        const length = inputElement.value.length;

        inputElement.setSelectionRange(length, length);
    };

    // ! Doesn't work on iOS (at least on latest 17 version)
    // if (isIos) {
    //     const temporaryElement = document.createElement('input');

    //     temporaryElement.type                = 'text';
    //     temporaryElement.style.position      = 'absolute';
    //     temporaryElement.style.top           = `${(target.offsetTop + 7)}px`;
    //     temporaryElement.style.left          = `${target.offsetLeft}px`;
    //     temporaryElement.style.height        = '1px';
    //     temporaryElement.style.opacity       = '0';
    //     temporaryElement.style.zIndex        = '-9999';
    //     temporaryElement.style.pointerEvents = 'none';

    //     document.body.appendChild(temporaryElement);
    //     temporaryElement.focus();
    // }

    setTimeout(() => {
        target.focus();
        target.click();

        if (target.value) {
            placeCursorAtEnd(target);
        }

        // isIos && document.body.removeChild(temporaryElement);
    }, timeout);
};

if (typeof $ === 'undefined') {
    $ = jQuery; // eslint-disable-line
}

/**
 * Document ready
 */
$(() => {
    let loadTimer = 0;

    // Calc correct app height for mobile devices
    document.documentElement.style.setProperty('--app-height', window.innerHeight + 'px');
    $(window).on('resize', () => {
        document.documentElement.style.setProperty('--app-height', window.innerHeight + 'px');

        // Remove transitions when resizing
        if (loadTimer) {
            clearTimeout(loadTimer);
            loadTimer = null;
        } else {
            $('body').addClass('preload');
        }

        loadTimer = setTimeout(() => {
            $('body').removeClass('preload');
            loadTimer = null;
        }, 100);
    });

    $('.js-toggle-text').on('click', (event) => {
        const target           = $(event.currentTarget);
        const onText           = target.data('on-text');
        const pressedAttribute = 'aria-pressed';
        const offText          = target.data('off-text');
        const pressed          = target.attr(pressedAttribute) === 'true' ? false : true;
        const buttonText       = pressed ? onText : offText;

        target.attr(pressedAttribute, pressed ? 'true' : 'false');

        target.contents().filter((index, item) => {
            const nodeType  = item.nodeType;
            const nodeValue = item.nodeValue;

            return nodeType === 3 && nodeValue.trim() !== '';
        }).replaceWith(buttonText);
    });
});

/**
 * Onload
 */
$(window).on('load', () => {
    $('body').removeClass('preload');
    $('body').addClass('is-loaded');
});

/**
 * Browser sync styles update
 */
document.addEventListener('DOMContentLoaded', () => {
    let existingStyle;

    if (getHash()) {
        const selector    = getHash();
        const target      = $(selector);
        const targetNode  = target.get(0);
        const totalOffset = getRootCssVariable('--header-anchor-offset');

        scrollToElement(targetNode, totalOffset, 0);
    }

    if (window.___browserSync___ && window.___browserSync___.socket) {
        const pkg = require('../../../../package.json');

        window.___browserSync___.socket.on('custom:styles:update', (data) => {
            if (existingStyle) {
                existingStyle.remove();
            }

            const oldStyles = document.querySelector('[rel="stylesheet"][href*="css/global"]');

            if (oldStyles) {
                oldStyles.remove();
            }

            const style = document.createElement('style');

            style.textContent = data.styles.replaceAll('../', `/wp-content/themes/${pkg.name}/assets/`);
            document.head.appendChild(style);

            existingStyle = style;
        });
    }
});
